import { Box } from '@chakra-ui/react';
import { BreakpointBox } from '../layout';
import { FC } from 'react';

export const EndOfFormSpacing: FC<{ mb?: number }> = ({ mb = 20 }) => (
  <BreakpointBox desktop={true} mobile={false} tablet={false}>
    <Box marginBottom={mb} />
  </BreakpointBox>
);
